export type appName =
  | 'Product Finder'
  | 'Seton Take Off'
  | 'Expert Sales Assistant'
  | 'Distributor Syndication'
  | 'Help'
  | 'User Management'
  | 'Home';

const UrlAppMap: Record<string, appName> = {
  '/': 'Home',
  '/chat': 'Expert Sales Assistant',
  '/product-finder': 'Product Finder',
  '/product-finder/custom-rankings': 'Product Finder',
  '/product-finder/etos': 'Product Finder',
  '/seton-pipe-markers': 'Seton Take Off',
  '/help': 'Help',
  '/users': 'User Management',
  '/distributor-syndication': 'Distributor Syndication',
};

export const getAppFromPath = (path: string): appName => {
  return UrlAppMap[path] || 'ESA';
};

export const ALLOWED_REDIRECT_URLS = Object.keys(UrlAppMap);

/**
 * Type for allowed redirect URLs - derived from UrlAppMap keys
 */
export type AllowedRedirectUrl = keyof typeof UrlAppMap;

/**
 * Validates if a URL pathname is in the allowed list
 * @param pathname The pathname to validate
 * @returns true if the pathname is allowed, false otherwise
 */
export const isAllowedRedirectUrl = (pathname: string): pathname is AllowedRedirectUrl => {
  return pathname in UrlAppMap;
};

/**
 * Sanitizes a URL and returns a safe redirect URL or default fallback
 * @param url The URL to sanitize (can include search params and hash)
 * @param defaultUrl The default URL to return if validation fails (defaults to home page)
 * @returns A safe pathname for redirect, or the default if invalid
 */
export const getSafeRedirectUrl = (url: string, defaultUrl: string = '/'): string => {
  try {
    // Remove any leading/trailing whitespace
    const trimmedUrl = url.trim();

    // Parse the URL to extract just the pathname (ignore query params and hash)
    const urlObj = new URL(trimmedUrl, window.location.origin);
    const pathname = urlObj.pathname;

    // Return pathname if it's in our allowlist, otherwise return default
    return isAllowedRedirectUrl(pathname) ? pathname : defaultUrl;
  } catch {
    // If URL parsing fails, return default
    return defaultUrl;
  }
};
